'use strict';

import _intersection from "lodash/intersection";
import _isEqual from "lodash/isEqual";
import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { matchPath } from 'react-router';
import TC_Wrapper from 'react-tag-commander';
import AppWrapper from 'AppWrapper';
import Pages from 'PagesExports';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import Loader from 'Pure/Loader';
import { safeNumeral, formatNum } from 'Shared/utilities';
import { routes } from 'Shared/Routes';
import config from '../../FullStack/Shared/config';
const TC_wrapper = TC_Wrapper.getInstance();
const {
  app,
  qwest,
  moment,
  numeral
} = window;
const TC_NAVIGATION_ID = '22';
const TC_TUNNEL_ID = '25';
const TC_SITE_ID = '5282';
const TC_DEFAULT_OPTIONS = {
  exclusions: ['datastorage', 'deduplication', 'internalvars', 'privacy']
};
const IS_PRERENDERED = document.querySelector('meta[rel="x-prerender-request-id"]') ? true : document.querySelector('[data-prerender="true"]') ? true : false;
const HAS_TAG_COMMANDER = document.location.origin + '/' !== config.pre_prod_url;
const EMPTY_SESSION = {
  user: {
    roles: []
  },
  allowed_routes: []
};
function getAllowedRoutes() {
  return (app.state.session.customized_authorizations || []).filter(action => action.front?.url && action.front?.reactComponent).reduce(function (accumulator, action) {
    accumulator[action.front.url] = {
      id: action.id,
      type: action.type,
      roles: action.roles,
      exact: action.front.exact !== false,
      component: Pages[action.front.reactComponent],
      allowed: action.allowed
    };
    return accumulator;
  }, {});
}
const TC_DEBUG = false;
export default class Application extends Component {
  state = {
    session: EMPTY_SESSION,
    allowed_routes: app.state.session.fetched === true ? getAllowedRoutes() : undefined,
    loading: app.state.session.fetched !== true,
    pages_404: window.window.__page_code === '404' ? [window.location.pathname] : []
  };
  fetching_session = app.state.session.fetched !== true;
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    delete window.__page_code;
    app.push({
      event: 'sessionChange',
      cb: component.handleSessionChange,
      global: true
    });
    app.push({
      event: 'sessionNeedsRefresh',
      cb: component.refreshSession,
      global: true
    });
    app.push({
      event: 'pageChange',
      cb: component.emitTCPageChange,
      global: true
    });
    app.push({
      event: 'TCPageView',
      cb: component.emitTCPageChange,
      global: true
    });
    app.push({
      event: 'TC_TunnelEvent',
      cb: component.emitTCTunnelView,
      global: true
    });
    app.push({
      event: 'TC_Click',
      cb: component.handleTCClickEvent,
      global: true
    });
    if (app.state.session.fetched !== true) {
      component.refreshSession({
        source: 'Application.DidMount'
      });
    } else if (state.allowed_routes) {
      component.pending_page_change = false;
      component.emitTCPageChange({
        source: 'Application.DidMount'
      });
    }
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.delete({
      event: 'sessionChange',
      cb: component.handleSessionChange,
      global: true
    });
    app.delete({
      event: 'sessionNeedsRefresh',
      cb: component.refreshSession,
      global: true
    });
    app.delete({
      event: 'pageChange',
      cb: component.emitTCPageChange,
      global: true
    });
    app.delete({
      event: 'TCPageView',
      cb: component.emitTCPageChange,
      global: true
    });
    app.delete({
      event: 'TC_TunnelEvent',
      cb: component.emitTCTunnelView,
      global: true
    });
    app.delete({
      event: 'TC_Click',
      cb: component.handleTCClickEvent,
      global: true
    });
  }
  componentDidUpdate(prev_props, prev_state) {
    const component = this,
      props = this.props,
      state = this.state;
    if (!prev_state.allowed_routes && state.allowed_routes) {
      if (component.pending_page_change === true) {
        component.pending_page_change = false;
        component.emitTCPageChange({
          source: 'Application.RoutesChanged'
        });
      }
    }
  }
  handleTCClickEvent = ({
    source,
    data = {}
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!HAS_TAG_COMMANDER) return;
    try {
      window.tC.container.reload({
        events: {
          click: [{}, {
            'categorie': 'clic',
            'click_action': data.action,
            'label': window.tc_vars?.page_name
          }]
        }
      });
    } catch (e) {
      return;
    }
  };
  loadTCNavigationContainer = ({
    source
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!HAS_TAG_COMMANDER) return;
    if (IS_PRERENDERED) return;
    const TC_variables = {
      'env_work': window.TC_env,
      'env_country': 'FR',
      'env_language': (navigator.language || 'FR').split('-')[0].toUpperCase(),
      'env_device': component.getDeviceType(),
      'env_currency': 'EUR'
    };
    Object.keys(TC_variables).forEach(function (name) {
      TC_wrapper.setTcVar(name, TC_variables[name]);
    });
    TC_wrapper.addContainer(TC_NAVIGATION_ID, window.TC_nav_url, 'body').then(function () {
      window.TC_nav_container_loaded = true;
      if (component.fetching_session === false) {
        component.setUserTCVars();
      }
      app.emit({
        event: 'pageChange',
        source: 'NavigationContainerLoaded'
      });
    });
  };
  setUserTCVars = () => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!HAS_TAG_COMMANDER) return;
    if (TC_DEBUG) console.log('setUserTCVars');
    const is__logged = app.state.session.user?.roles?.length > 0 ? 'yes' : 'no';
    if (TC_DEBUG) console.log('is__logged', is__logged);
    TC_wrapper.setTcVar('user_logged', is__logged);
    if (is__logged === 'yes') {
      TC_wrapper.setTcVar('user_id', app.state.session.sha_256_user_id);
      TC_wrapper.setTcVar('user_email', app.state.session.sha_256_email);
      if (app.state.session.user.roles.includes('admin')) {
        TC_wrapper.setTcVar('user_type', 'administrateur');
      } else if (app.state.session.user.roles.includes('hotelier')) {
        TC_wrapper.setTcVar('user_type', 'administrateur');
      } else if (app.state.session.user.roles.includes('company_employee')) {
        TC_wrapper.setTcVar('user_type', 'professionnel');
      } else if (app.state.session.user.roles.includes('company')) {
        TC_wrapper.setTcVar('user_type', 'entreprise');
      } else {
        TC_wrapper.setTcVar('user_type', 'particulier');
      }
    } else {
      TC_wrapper.setTcVar('user_id', '');
      TC_wrapper.setTcVar('user_type', '');
      TC_wrapper.setTcVar('user_email', '');
    }
  };
  reloadNavigationContainer = () => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!HAS_TAG_COMMANDER) return;
    if (TC_DEBUG) console.log('reloadNavigationContainer');
    TC_wrapper.reloadContainer(TC_SITE_ID, TC_NAVIGATION_ID, TC_DEFAULT_OPTIONS);
    if (TC_DEBUG) console.log('pageView');

    // page view event
    TC_wrapper.triggerEvent('pageview', {}, window.tc_vars);
  };
  loadTunnelContainer = () => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!HAS_TAG_COMMANDER) return;
    if (IS_PRERENDERED) return;
    TC_wrapper.addContainer(TC_TUNNEL_ID, window.TC_tunnel_url, 'body').then(function () {
      window.TC_tunnel_container_loaded = true;
    });
  };
  reloadTunnelContainer = () => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!HAS_TAG_COMMANDER) return;
    if (TC_DEBUG) console.log('reloadTunnelContainer');
    TC_wrapper.reloadContainer(TC_SITE_ID, TC_TUNNEL_ID, TC_DEFAULT_OPTIONS);
  };
  removeTunnelContainer = () => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!HAS_TAG_COMMANDER) return;
    TC_wrapper.removeContainer(TC_TUNNEL_ID);
    window.TC_tunnel_container_loaded = false;
  };
  resetTCData = () => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!HAS_TAG_COMMANDER) return;
    const TC_variables = {
      'id_reservation': '',
      'type_reservation': '',
      'ville_reservation': '',
      'date_reservation': '',
      'etablissement': '',
      'nom_espace': '',
      'quantite_siege': '',
      'creneau_reservation': '',
      'service_supplementaire': '',
      'unitprice_tf': '',
      'unitprice_ati': '',
      'totalprice_tf': '',
      'totalprice_ati': '',
      'env_business': 'btoc'
    };
    Object.keys(TC_variables).forEach(name => TC_wrapper.setTcVar(name, TC_variables[name]));
  };
  setTCData = ({
    source,
    data = {},
    route_infos = {}
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!HAS_TAG_COMMANDER) return;
    const {
      page,
      template,
      env_business
    } = data;
    if (TC_DEBUG) console.log('setTCData', source, data);
    component.resetTCData();
    TC_wrapper.setTcVar('env_template', template || route_infos.TC_template);
    TC_wrapper.setTcVar('page_name', page || route_infos.TC_page);
    TC_wrapper.setTcVar('env_business', env_business || route_infos.TC_business || 'btob');
    if (route_infos['TC_with_booking_type'] && !data.type_reservation) {
      const widget_type = window.localStorage.getItem('widget-space-type');
      if (widget_type) {
        TC_wrapper.setTcVar('type_reservation', widget_type === 'coworking' ? 'coworking' : 'seminaire');
      }
    }
    ['type_reservation', 'ville_reservation', 'date_reservation', 'etablissement', 'nom_espace', 'creneau_reservation', 'quantite_siege', 'unitprice_tf', 'unitprice_ati'].filter(TC_name => data[TC_name] !== undefined).forEach(TC_name => TC_wrapper.setTcVar(TC_name, data[TC_name]));
  };
  emitTCPageChange = ({
    source,
    data = {}
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!HAS_TAG_COMMANDER) return;
    const {
      page,
      template
    } = data;
    if (!state.allowed_routes) {
      component.pending_page_change = true;
      return;
    }
    if (TC_DEBUG) console.log('emitTCPageChange', source);
    const current_route = Object.keys(state.allowed_routes || {}).find(function (url) {
      return matchPath(document.location.pathname, {
        path: url,
        ...(state.allowed_routes || {})[url]
      });
    });
    const route_infos = current_route ? routes.find(data => data.front?.url === current_route) : undefined;
    const natural_source = ['AppWrapper', 'Application.refreshSession', 'Application.RoutesChanged', 'Application.DidMount'].includes(source);
    if (!route_infos || !template && !route_infos.TC_template) {
      return;
    } else if (natural_source && route_infos.TC_hold === true) {
      return component.TC_holding = true;
    } else if (source === 'NavigationContainerLoaded' && component.TC_holding) {
      return;
    }
    component.TC_holding = false;
    if (source !== 'NavigationContainerLoaded') {
      component.setTCData({
        source,
        data,
        route_infos
      });
    }
    const tunnel_templates = ['confirmation_B2B', 'confirmation_B2C'];
    if (tunnel_templates.includes(route_infos.TC_template)) {
      if (window.TC_tunnel_container_loaded === true) {
        component.reloadTunnelContainer();
      } else {
        component.loadTunnelContainer();
      }
    } else if (window.TC_tunnel_container_loaded === true) {
      component.removeTunnelContainer();
    }
    if (window.TC_nav_container_loaded === true) {
      component.reloadNavigationContainer();
    } else {
      component.loadTCNavigationContainer({
        source
      });
    }
  };
  emitTCTunnelView = ({
    source,
    data
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!HAS_TAG_COMMANDER) return;
    const user = app.state.session.user?.id ? app.state.session.user : undefined;
    const TC_vars = {
      env_template: data.template,
      page_name: data.page,
      id_reservation: data.booking_id,
      type_reservation: data.type,
      ville_reservation: data.city,
      date_reservation: moment(data.date).format('DD/MM/YYYY'),
      etablissement: data.etablishment,
      nom_espace: data.space,
      quantite_siege: data.people,
      creneau_reservation: data.booking,
      service_supplementaire: data.services,
      unitprice_tf: numeral(safeNumeral(data.price)).divide(1.2).format('0.00'),
      unitprice_ati: formatNum(data.price, '0.00'),
      totalprice_tf: numeral(safeNumeral(data.price_with_services)).divide(1.2).format('0.00'),
      totalprice_ati: formatNum(data.price_with_services, '0.00')
    };
    if (user) {
      Object.assign(TC_vars, {
        user_logged: 'yes',
        user_type: (app.state.session.user.roles || []).includes('company_employee') ? 'professionnel' : 'particulier',
        user_email: app.state.session.sha_256_email,
        user_id: app.state.session.sha_256_user_id
      });
    } else {
      Object.assign(TC_vars, {
        user_logged: 'no',
        user_id: '',
        user_email: '',
        user_type: 'particulier'
      });
    }
    if (TC_DEBUG) console.info('tunnel view', TC_vars);
    Object.keys(TC_vars).forEach(name => TC_wrapper.setTcVar(name, TC_vars[name] || ''));
    if (window.TC_tunnel_container_loaded === true) {
      component.reloadTunnelContainer();
    } else {
      component.loadTunnelContainer();
    }
  };
  handleSessionChange = ({
    source,
    data
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    const allowed_routes = getAllowedRoutes();
    if (_isEqual(state.allowed_routes || {}, allowed_routes)) {
      return;
    }
    component.setState({
      allowed_routes: allowed_routes
    });
  };
  refreshSession = ({
    source,
    data = {}
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (data.prevent_loading !== true) {
      component.setState({
        loading: true
      });
    }
    qwest.post('/get-session').then(function (xhr, response) {
      component.fetching_session = false;
      app.state.session = response || undefined;
      app.state.session.fetched = true;
      component.setUserTCVars();
      if (app.state.session.user?.roles?.includes?.('company_employee')) {
        window.localStorage.setItem('widget-space-type', 'lounge');
      }
      app.emit({
        event: 'sessionChange',
        source: component
      });
      component.setState({
        loading: false
      });
      if (typeof data.then === 'function') {
        data.then(response);
      } else if (data?.url)
        // page change so TC will be triggered
        {
          app.navigateTo(data?.url);
        } else if (source === 'Application.DidMount') {
        app.emit({
          event: 'pageChange',
          source: 'Application.refreshSession'
        });
      }
      // no page change so TC is triggered manually
      else if (component.fetching_session && window.TC_nav_container_loaded === true) {
        component.reloadNavigationContainer();
      }
      component.fetching_session = false;
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  getDeviceType = () => {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
      return 't';
    } else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
      return 'm';
    }
    return 'd';
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const user = app.state.session.user ? app.state.session.user || {
      roles: []
    } : {
      roles: []
    };
    const is__authenticated = user.id !== undefined;
    const is__admin = (user.roles || []).includes('admin');
    const roles = is__authenticated ? user.roles || [] : [];
    let rendered_routes = Object.keys(state.allowed_routes || {}).map(function (path, i) {
      let page_component = state.allowed_routes[path].component;
      let role_type = state.allowed_routes[path].type;
      let allowed_roles = state.allowed_routes[path].roles;
      let exact = state.allowed_routes[path].exact !== false;
      let is__allowed = false;
      if (is__admin || role_type === 'public') {
        is__allowed = true;
      } else if (role_type === 'connected' && is__authenticated) {
        is__allowed = true;
      } else {
        is__allowed = _intersection(allowed_roles, roles).length > 0;
      }
      const key = state.allowed_routes[path].name || i;
      const route = is__allowed ? /*#__PURE__*/React.createElement(Route, {
        exact: exact,
        path: path,
        component: page_component,
        key: key
      }) : /*#__PURE__*/React.createElement(Route, {
        exact: exact,
        path: path,
        component: Pages['NotAllowedPage'],
        key: key
      });
      return route;
    });
    rendered_routes.push( /*#__PURE__*/React.createElement(Route, {
      component: Pages['NotFoundPage'],
      key: "NotFound"
    }));
    if (state.pages_404.includes(window.location.pathname)) {
      rendered_routes.unshift( /*#__PURE__*/React.createElement(Route, {
        component: Pages['NotFoundPage'],
        key: "NotFound-current",
        exact: true,
        path: window.location.pathname
      }));
    }
    let output = /*#__PURE__*/React.createElement(Router, null, /*#__PURE__*/React.createElement(AppWrapper, {
      routes: rendered_routes
    }));
    const loader = /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    });
    return state.loading ? loader : output;
  }
}
